import { isNil } from '../Monads';

const removeNilValues = (obj) => Object
  .entries(obj)
  .reduce((acc, [key, value]) => (isNil(value) ? acc : { ...acc, [key]: value }), {});

export default removeNilValues;
